module.exports = __webpack_public_path__ + "img/quit.a9287097.svg";